module.exports = __webpack_public_path__ + "img/mark.828d4709.png";